// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"f5bb33c1","137":"040a6fb6","434":"ec61df4b"}[chunkId] + ".chunk.css";
};